import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { handleResetIframe } from "../../../actions/headerMenu/headerMenu";
import { Spin, Tooltip } from "antd";
import config from "../../../helper/config";


const ApplicationPreview = () => {
  const dispatch = useDispatch();
  const loginDetials = useSelector((state) => state.loginReducer.loginDetials);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    //Receiving the message from child
    window.addEventListener("message", handleIframeTask);

    window.onpageshow = () => {
      dispatch(handleResetIframe(false));
    };
    const iframe = document.querySelector("iframe");
    iframe.contentWindow.postMessage("Show", "*");
  }, []);

  const handleIframeTask = (e) => {
    if (e.data === "submitted form") {
      document.getElementsByClassName("content__area")[0].scroll(0, 0);
    }
  };

  const src = `${config.RingBuilderURL}?DealerLink=${loginDetials.responseData.dealerId}&isChange=True&headerTab=chooseYourSetting`;
  const hideSpinner = () => {
    setLoading(false);
    document.getElementsByClassName("content__area")[0].scroll(0, 0);
    dispatch(handleResetIframe(false));
    //Send Message to child
    const iframe = document.querySelector("iframe");
    iframe.contentWindow.postMessage("Show", "*");
  };

  return (
    <React.Fragment>
      {/* <h4 className="mr-3">Application Preview</h4> */}
      <Spin spinning={loading}>
        <iframe
          onLoad={() => hideSpinner()}
          width="100%"
          className="application__preview"
          //height="1000px"
          src={src}
        ></iframe>
      </Spin>
    </React.Fragment>
  );
};

export default ApplicationPreview;
